import { D as DelegatesAria } from './delegates-aria.js';
import { V as VividElement, D as DOM, a as attr } from './vivid-element.js';
import { F as FormAssociated } from './form-associated.js';

var __defProp = Object.defineProperty;
var __decorateClass = (decorators, target, key, kind) => {
  var result = void 0 ;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (decorator(target, key, result) ) || result;
  if (result) __defProp(target, key, result);
  return result;
};
class VividFoundationButton extends DelegatesAria(
  FormAssociated(VividElement)
) {
  constructor() {
    super(...arguments);
    /**
     * @internal
     */
    this.proxy = document.createElement("input");
    /**
     * Prevent events to propagate if disabled
     * @internal
     */
    this.handleClick = (e) => {
      if (this.disabled) {
        e.stopPropagation();
      }
    };
    /**
     * Submits the parent form
     */
    this.handleSubmission = () => {
      if (!this.form) {
        return;
      }
      this.attachProxy();
      this.form.requestSubmit(this.proxy);
      this.detachProxy();
    };
    /**
     * Resets the parent form
     */
    this.handleFormReset = () => {
      this.form?.reset();
    };
    /**
     * Overrides the focus call for where delegatesFocus is unsupported.
     * This check works for Chrome, Edge Chromium, FireFox, and Safari
     * Relevant PR on the Firefox browser: https://phabricator.services.mozilla.com/D123858
     */
    this.handleUnsupportedDelegatesFocus = () => {
      if (this.$fastController.definition.shadowOptions) {
        if (window.ShadowRoot && /* eslint-disable-next-line */
        !window.ShadowRoot.prototype.hasOwnProperty("delegatesFocus") && this.$fastController.definition.shadowOptions.delegatesFocus) {
          Object.defineProperty(this, "focus", {
            value: () => {
              this.control.focus();
            },
            configurable: true
          });
        }
      }
    };
  }
  // @ts-expect-error Function is delcared but not used
  formactionChanged() {
    if (this.proxy instanceof HTMLInputElement) {
      this.proxy.formAction = this.formaction;
    }
  }
  // @ts-expect-error Function is delcared but not used
  formenctypeChanged() {
    if (this.proxy instanceof HTMLInputElement) {
      this.proxy.formEnctype = this.formenctype;
    }
  }
  // @ts-expect-error Function is delcared but not used
  formmethodChanged() {
    if (this.proxy instanceof HTMLInputElement) {
      this.proxy.formMethod = this.formmethod;
    }
  }
  // @ts-expect-error Function is delcared but not used
  formnovalidateChanged() {
    if (this.proxy instanceof HTMLInputElement) {
      this.proxy.formNoValidate = this.formnovalidate;
    }
  }
  // @ts-expect-error Function is delcared but not used
  formtargetChanged() {
    if (this.proxy instanceof HTMLInputElement) {
      this.proxy.formTarget = this.formtarget;
    }
  }
  // @ts-expect-error Function is delcared but not used
  typeChanged(previous, next) {
    if (this.proxy instanceof HTMLInputElement) {
      this.proxy.type = this.type;
    }
    next === "submit" && this.addEventListener("click", this.handleSubmission);
    previous === "submit" && this.removeEventListener("click", this.handleSubmission);
    next === "reset" && this.addEventListener("click", this.handleFormReset);
    previous === "reset" && this.removeEventListener("click", this.handleFormReset);
  }
  /** {@inheritDoc (FormAssociated:interface).validate} */
  validate() {
    super.validate(this.control);
  }
  /**
   * @internal
   */
  connectedCallback() {
    super.connectedCallback();
    this.proxy.setAttribute("type", this.type);
    this.handleUnsupportedDelegatesFocus();
    if (this.autofocus) {
      DOM.queueUpdate(() => {
        this.focus();
      });
    }
    const elements = Array.from(this.control.children);
    if (elements) {
      elements.forEach((span) => {
        span.addEventListener("click", this.handleClick);
      });
    }
  }
  /**
   * @internal
   */
  disconnectedCallback() {
    super.disconnectedCallback();
    const elements = Array.from(this.control.children);
    if (elements) {
      elements.forEach((span) => {
        span.removeEventListener("click", this.handleClick);
      });
    }
  }
}
__decorateClass([
  attr({ mode: "boolean" })
], VividFoundationButton.prototype, "autofocus");
__decorateClass([
  attr({ attribute: "form" })
], VividFoundationButton.prototype, "formId");
__decorateClass([
  attr
], VividFoundationButton.prototype, "formaction");
__decorateClass([
  attr
], VividFoundationButton.prototype, "formenctype");
__decorateClass([
  attr
], VividFoundationButton.prototype, "formmethod");
__decorateClass([
  attr({ mode: "boolean" })
], VividFoundationButton.prototype, "formnovalidate");
__decorateClass([
  attr
], VividFoundationButton.prototype, "formtarget");
__decorateClass([
  attr
], VividFoundationButton.prototype, "type");

export { VividFoundationButton as V };
